import { createSlice } from "@reduxjs/toolkit";

// Создаем slice (редьюсер + экшены)
const emailSlice = createSlice({
  name: "email",
  initialState: { email: "" },
  reducers: {
    setEmailShow: (state, action) => {
      state.email = action.payload;
    },
    setEmailHide: (state) => {
      state.email = "";
    },
  },
});

// Экшены
export const { setEmailShow, setEmailHide } = emailSlice.actions;

export default emailSlice.reducer;
